import ShortText from './Icons/short-text.svg'
import LongText from './Icons/long-text.svg'
import YesNo from './Icons/yes-no.svg'
import MultipleChoice from './Icons/multi-choice.svg'
import Rating from './Icons/rating.svg'
import DropdownList from './Icons/dropdownlist.svg'
import DatePicker from './Icons/datetime-picker.svg'
import FileUpload from './Icons/file-upload.svg'
import Statement from './Icons/statement.svg'
import Scheduler from './Icons/scheduler.svg'
import ImgUploadCloud from './Images/upload-cloud.svg'



export  {
ShortText,
LongText,
YesNo,
MultipleChoice,
Rating,
DropdownList,
DatePicker,
FileUpload,
Statement,
Scheduler,
ImgUploadCloud
}